import { useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  convert as newConvert,
  Gallon as newGallon,
  Pound as newPound
} from '@syngenta-digital/package-typescript-cropwise-financials-uom';
import {
  convert as legacyConvert,
  Gallon as legacyGallon,
  Pound as legacyPound
} from '@agconnections/agc_unitconversion';
import { Context } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import {
  UOM_CONVERSION_MIGRATION,
  UOM_CONVERSION_MIGRATION_BY_ORG
} from 'constants/uomConversionFlags';

const useUomConvert = () => {
  const flags = useFlags();
  const [{ organization }] = useContext(Context);
  const useNewPackage = featureFlagRenderItem(
    flags[UOM_CONVERSION_MIGRATION],
    flags[UOM_CONVERSION_MIGRATION_BY_ORG],
    organization?.id
  );
  return useNewPackage ? newConvert : legacyConvert;
};

export default useUomConvert;

export const useUomPackage = () => {
  const flags = useFlags();
  const [{ organization }] = useContext(Context);
  const useNewPackage = featureFlagRenderItem(
    flags[UOM_CONVERSION_MIGRATION],
    flags[UOM_CONVERSION_MIGRATION_BY_ORG],
    organization?.id
  );
  return useNewPackage
    ? { Gallon: newGallon, Pound: newPound }
    : { Gallon: legacyGallon, Pound: legacyPound };
};
